import { getAuth, onAuthStateChanged } from '@firebase/auth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { useState, useEffect, useContext, createContext } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const config = {
    apiKey: "AIzaSyAB10QoTXFcdUCaVSbZntf_d_cSj7OSjHM",
    authDomain: "gottea-3daa4.firebaseapp.com",
    databaseURL: "https://gottea-3daa4.firebaseio.com",
    projectId: "gottea-3daa4",
    storageBucket: "gottea-3daa4.appspot.com",
    messagingSenderId: "691417546594",
    appId: "1:691417546594:web:536ef6d0c379fb5947b63b",
    measurementId: "G-ED1W31MB1J"
  };

export const firebaseApp = firebase.apps.length
  ? firebase.app()
  : firebase.initializeApp(config);
const db = getFirestore(firebaseApp);
export const AuthContext = createContext();

export const AuthContextProvider = props => {
  const [user, setUser] = useState()
  const [error, setError] = useState()
  const [userRole, setUserRole] = useState(null)
  const [loadingRole, setLoadingRole] = useState(false)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(), async (authUser) => {
      setUser(authUser)
      
      // Fetch user role when user logs in
      if (authUser && authUser.uid) {
        try {
          setLoadingRole(true)
          const userDocRef = doc(db, 'adminUsers', authUser.uid)
          const userDocSnap = await getDoc(userDocRef)
          
          if (userDocSnap.exists()) {
            const userData = userDocSnap.data()
            setUserRole(userData.role || null)
          } else {
            setUserRole(null)
          }
        } catch (err) {
          console.error('Error fetching user role:', err)
          setUserRole(null)
        } finally {
          setLoadingRole(false)
        }
      } else {
        setUserRole(null)
        setLoadingRole(false)
      }
    }, setError)
    return () => unsubscribe()
  }, [])
  
  return <AuthContext.Provider value={{ user, error, userRole, loadingRole }} {...props} />
}

export const useAuthState = () => {
  const auth = useContext(AuthContext)
  return { ...auth, isAuthenticated: auth.user != null }
}
